import { AppleLogo, GooglePlayLogo } from "@phosphor-icons/react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../lib/site";

const Badge = ({ href, icon: Icon, top, bottom, testid }) => (
  <a
    href={href}
    data-testid={testid}
    className="group inline-flex items-center gap-3 rounded-2xl bg-maraca-navy px-5 py-3 text-white transition-transform duration-300 hover:-translate-y-1 hover:bg-[#0a3179] focus:outline-none focus:ring-2 focus:ring-maraca-teal focus:ring-offset-2"
  >
    <Icon size={30} weight="fill" className="shrink-0" />
    <span className="text-left leading-tight">
      <span className="block text-[10px] uppercase tracking-widest text-white/70">{top}</span>
      <span className="block font-display text-lg font-bold">{bottom}</span>
    </span>
  </a>
);

export const AppBadges = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <Badge href={APP_STORE_URL} icon={AppleLogo} top="Baixe na" bottom="App Store" testid="app-store-btn" />
    <Badge href={PLAY_STORE_URL} icon={GooglePlayLogo} top="Disponível no" bottom="Google Play" testid="google-play-btn" />
  </div>
);
